<div *ngIf="deliveryOrderDetails" class="tab-section">
	<!-- Xpress Transaction Section -->
	<div class="tab-section-block">
		<h4 class="section-title">Xpress Transaction</h4>
		<div class="details-grid">
			<div class="flex align-items-center py-2">
				<div class="field-name w-6">Transaction Date:</div>
				<div class="field-value w-6">{{ deliveryOrderDetails.XpressPaymentTransaction?.CreatedAt | formatDate:'ddd., MMMM D, YYYY, HH:mm' }}</div>
			</div>
			<div class="flex align-items-center py-2">
				<div class="field-name w-6">Transaction Type:</div>
				<div class="field-value w-6">{{ deliveryOrderDetails.XpressPaymentTransaction?.OperationTypeText | textTransform:TextTransformType.Titlecase }}</div>
			</div>
			<div class="flex align-items-center py-2">
				<div class="field-name w-6">Transaction Time:</div>
				<div class="field-value w-6">{{ deliveryOrderDetails.XpressPaymentTransaction?.CreatedAt | formatDate:'HH:mm' }}</div>
			</div>
		</div>
	</div>

	<!-- Payment Section -->
	<div class="tab-section-block">
		<h4 class="section-title">Payment</h4>
		<div class="details-grid">
			<div class="flex align-items-center py-2">
				<div class="field-name w-6">Payment Method:</div>
				<div class="field-value w-6">{{ deliveryOrderDetails.XpressPaymentTransaction?.PaymentMethodText | textTransform:TextTransformType.Titlecase:'N/A' }}</div>
			</div>
			<div class="flex align-items-center py-2">
				<div class="field-name w-6">Transaction amount:</div>
				<div class="field-value w-6">{{ deliveryOrderDetails.XpressPaymentTransaction?.TransactionAmount | formatCurrency }}</div>
			</div>
			<div class="flex align-items-center py-2">
				<div class="field-name w-6">Partner TX ID:</div>
				<div class="field-value w-6">{{ deliveryOrderDetails.XpressPaymentTransaction?.PartnerTXID | textTransform:TextTransformType.Titlecase:'--' }}</div>
			</div>
			<div class="flex align-items-center py-2">
				<div class="field-name w-6">Transaction Status:</div>
				<div class="field-value w-6">{{ (deliveryOrderDetails.XpressPaymentTransaction?.Status === 'PAID') ? 'Success' :  deliveryOrderDetails.XpressPaymentTransaction?.Status | textTransform:TextTransformType.Titlecase:'--' }}</div>
			</div>
		</div>
	</div>

	<!-- Payment Processor Section -->
	<div class="tab-section-block">
		<h4 class="section-title">Payment Processor</h4>
		<div class="details-grid">
			<div class="flex align-items-center py-2">
				<div class="field-name w-6">Partner:</div>
				<div class="field-value w-6">{{ 'Xendit' | textTransform:TextTransformType.Titlecase:'--' }}</div>
			</div>
			<div class="flex align-items-center py-2">
				<div class="field-name w-6">TX time:</div>
				<div class="field-value w-6">{{ deliveryOrderDetails.XpressPaymentTransaction?.CreatedAt | formatDate:'HH:mm:ss' }}</div>
			</div>
			<div class="flex align-items-center py-2">
				<div class="field-name w-6">Reference:</div>
				<div class="field-value w-6">{{ deliveryOrderDetails.XpressPaymentTransaction?.Id | textTransform:TextTransformType.Titlecase:'--' }}</div>
			</div>
		</div>
	</div>
</div>
